export const mapLocaleToDateServiceLocale = {
    "en": "en",
    "fr": "fr",
    "es": "es",
    "ru": "ru",
    "fa": "fa",
    "zh": "zh-cn",
    "tr": "tr",
}